import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../components/navbar/navbarComponent";
import { useEffect, useState } from "react";
import { postSecuestro } from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import { generatePdf } from "./generatePdf";
import ErrorModal from "../../components/modals/errorModal";
import SuccessModal from "../../components/modals/successModal";
import Button from "../../components/button";

function ConfirmarDatos() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ingresoDetalles = useSelector((state) => state.ingresoDetalles);
  const ingresoFoto = useSelector((state) => state.ingresoFoto);
  const datosConfirmarIngreso = useSelector((state) => state.datosConfirmarIngreso);
  const userId = useSelector((state) => state.currentUserId);
  const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const openErrorModal = (message) => setErrorModal({ show: true, message });
  const closeErrorModal = () => setErrorModal({ show: false, message: "" });


  /* --------------------Formateando fecha y hora de Acta----------------------------- */

  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    const formatter = new Intl.DateTimeFormat("es-AR", {
      dateStyle: "short",
      timeStyle: "short",
      timeZone: "America/Argentina/Buenos_Aires",
    });

    if (datosConfirmarIngreso?.actaFecha_hora) {
      // Convertir "15/10/2024, 12:50:00" a formato válido para Date
      const [fecha, hora] = datosConfirmarIngreso.actaFecha_hora.split(", ");
      const [dia, mes, anio] = fecha.split("/");
      const dateString = `${anio}-${mes}-${dia}T${hora}`;

      const date = new Date(dateString);
      setFormattedDate(formatter.format(date));
    }
  }, [datosConfirmarIngreso]);

  /*  ------------------------------------------------------------------- */

  const [data, setData] = useState({});
  const [nroActa, setNroActa] = useState("Sin acta");

  useEffect(() => {
    setData({
      ...datosConfirmarIngreso,
      ...ingresoDetalles,
      userId,
      foto: ingresoFoto,
    });

    if (datosConfirmarIngreso?.actaNro) {
      setNroActa(datosConfirmarIngreso.actaNro);
    } else {
      setNroActa("Sin acta");
    }
  }, [datosConfirmarIngreso, ingresoDetalles, ingresoFoto, userId]);


  const [loading, setLoading] = useState(false);


  const handleConfirm = async () => {
    setLoading(true);
    const formData = new FormData();

    // Agregar los datos al FormData
    for (const key in data) {
      if (key === "foto" && data[key]) {
        formData.append("foto", data[key]);
      } else {
        formData.append(key, data[key]);
      }
    }

    try {
      const newSecuestro = await dispatch(postSecuestro(formData));

      const pdfResponse = await generatePdf({ idSecuestro: newSecuestro.id, nroActa });
      if (pdfResponse !== "PDF generado con éxito") {
        throw new Error(pdfResponse);
      }

      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error:", error);
      if (error.message.includes("PDF")) {
        openErrorModal("El secuestro se guardó correctamente, pero hubo un error al generar el PDF.");
      } else {
        openErrorModal("Hubo un error al guardar el secuestro. Por favor, intenta nuevamente.");
      }
    } finally {
      setLoading(false);
      navigate("/inicio")
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleback = () => {
    navigate(-1);
  };

  return (
    <div>
      <Navbar />
      <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF]">
        <div className="text-[#3d4245] text-[32px] font-bold font-inter my-[2rem]">
          Confirmar datos
        </div>
        <div className="sm:w-[40rem] w-[20rem] flex-col justify-start items-start gap-4 inline-flex">
          <div className="sm:w-[40rem] w-[20rem] flex-col justify-start items-start gap-3 flex">
            <div className="sm:w-[40rem] w-[20rem] justify-start items-start gap-3 inline-flex   flex-col sm:flex-row">
              <div className="w-full grow  basis-0 p-4 bg-white rounded-lg border border-[#c5dfff] flex-col justify-start items-start gap-3 inline-flex">
                <div className="text-[#0a5477] text-base font-bold font-inter uppercase">
                  ACTA
                </div>
                <div className=" flex-col justify-center items-start gap-2 flex">
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      №:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {/* {datosConfirmarIngreso.actaNro} */}{nroActa}
                    </div>
                  </div>
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      Inspector:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {datosConfirmarIngreso.actaInspector}
                    </div>
                  </div>
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      Lugar:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {datosConfirmarIngreso.actaLugar}
                    </div>
                  </div>
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      Fecha / hora:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {formattedDate}{/* {datosConfirmarIngreso.actaFecha_hora} */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="grow w-full basis-0 p-4 bg-white rounded-lg border border-[#c5dfff] flex-col justify-start items-start gap-3 inline-flex">
                <div className="text-[#0a5477] text-base font-bold font-inter uppercase">
                  Infractor
                </div>
                <div className=" flex-col justify-center items-start gap-2 flex">
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      Nombre:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {datosConfirmarIngreso.infractorNombre}
                    </div>
                  </div>
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      DNI:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {datosConfirmarIngreso.infractorDni}
                    </div>
                  </div>
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      CUIL:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {datosConfirmarIngreso.infractorCuil}
                    </div>
                  </div>
                  <div className="justify-start items-center gap-1 inline-flex">
                    <div className="text-[#3d4245] text-lg font-bold font-inter">
                      Sexo:
                    </div>
                    <div className="text-[#687073] text-base font-medium font-inter">
                      {datosConfirmarIngreso.infractorSexo}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="self-stretch  p-4 bg-white rounded-lg border border-[#c5dfff] flex-col justify-start items-start gap-3 flex">
              <div className="text-[#0a5477] text-sm font-bold font-inter uppercase">
                vehículo
              </div>
              <div className="self-stretch flex-col justify-center items-start gap-2 flex">
                <div className="justify-start items-center gap-1 inline-flex">
                  <div className="text-[#3d4245] text-lg font-bold font-inter">
                    Dominio:
                  </div>
                  <div className="text-[#687073] text-base font-medium font-inter">
                    {datosConfirmarIngreso.vehiculoDominio}
                  </div>
                </div>
                <div className="justify-start items-center gap-1 inline-flex">
                  <div className="text-[#3d4245] text-lg font-bold font-inter">
                    Tipo de vehículo:
                  </div>
                  <div className="text-[#687073] text-base font-medium font-inter">
                    {datosConfirmarIngreso.vehiculoTipo}
                  </div>
                </div>
                <div className="justify-start items-center gap-1 inline-flex">
                  <div className="text-[#3d4245] text-lg font-bold font-inter">
                    Marca:
                  </div>
                  <div className="text-[#687073] text-base font-medium font-inter">
                    {datosConfirmarIngreso.vehiculoMarca}
                  </div>
                </div>
                <div className="justify-start items-center gap-1 inline-flex">
                  <div className="text-[#3d4245] text-lg font-bold font-inter">
                    Modelo:
                  </div>
                  <div className="text-[#687073] text-base font-medium font-inter">
                    {datosConfirmarIngreso.vehiculoModelo}
                  </div>
                </div>
              </div>
            </div>
            {datosConfirmarIngreso.infracciones ? (
              <div className="self-stretch  p-4 bg-white rounded-lg border border-[#c5dfff] flex-col justify-start items-start gap-1 flex">
                <div className="text-[#0a5477] text-sm font-bold font-inter uppercase">
                  Infracciones
                </div>
                <div className="text-[#687073] text-base font-medium font-inter">
                  {datosConfirmarIngreso.infracciones?.map((infr) => (
                    <div className="divide-y divide-[#61ABCF] px-4 py-2 ">
                      {infr.digesto}
                      {infr.descrip}
                    </div>
                  ))}
                </div>
              </div>
            ) : ("")}
          </div>
          <div className="self-stretch mb-[2rem] items-center gap-2 inline-flex ">
            <Button
              variant="secondary"
              size="lg"
              onClick={() => handleback()}
              className="grow basis-0"
            >
              Volver atrás
            </Button>

            <Button
              size="lg"
              onClick={handleConfirm}
              loading={loading}
              disabled={tipoCurrentUser === "viewer"}
              className="grow basis-0"
            >
              Guardar e imprimir código
            </Button>
          </div>
        </div>
      </div>
      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={closeSuccessModal}
          message="PDF descargado con éxito"
        />
      )}
      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
    </div>
  );
}

export default ConfirmarDatos;
